<script>
import SelectBox from '@/components/pc/radio/ipradio/atoms/SelectBox.vue'
import ToggleSwitch from '@/components/pc/radio/ipradio/atoms/ToggleSwitch.vue'
import SettingGroup from '@/components/pc/radio/ipradio/organisms/layout/SettingGroup.vue'
import SettingItem from '@/components/pc/radio/ipradio/organisms/layout/SettingItem.vue'
import { BC, FUNCTION_LIST } from '@/components/pc/radio/ipradio/config/BCconstants'
import { useRadioSettingsStore } from '@/components/pc/radio/ipradio/stores/bcRadioSettings'

export default {
  name: 'MicKeyREM',
  components: { SelectBox, ToggleSwitch, SettingGroup, SettingItem },
  data() {
    const radioSettings = useRadioSettingsStore()

    const makeFunctionOpts = () =>
      FUNCTION_LIST.map((ele) => {
        if (ele.type.key && ele.function?.function) return { label: ele.label, value: ele.value }
      }).filter(Boolean)

    const makeHoldFunctionOpts = () =>
      FUNCTION_LIST.map((ele) => {
        if (ele.type.key && ele.function?.holdFunction) return { label: ele.label, value: ele.value }
      }).filter(Boolean)

    return {
      radioSettings,
      setting: radioSettings.getTempSetting(),

      selectboxOptions: {
        function: makeFunctionOpts(),
        holdFunction: makeHoldFunctionOpts(),
      },

      form: {
        selectbox: {
          rem: {
            // 初期値は後で設定から上書きされます
            function: '',
            holdFunction: '',
          },
        },
        toggle: {
          rem: { swapFunctionsREMandPTT: false },
        },
      },

      functionSelectDisable: false,
      holdFunctionSelectDisable: false,
    }
  },
  watch: {
    form: {
      deep: true,
      handler() {
        this.transForm2Setting()
        this.radioSettings.saveTempSetting(this.setting)
      },
    },
  },
  methods: {
    transForm2Setting() {
      const data = this.setting.KeyAssignment.MicKey

      const fn = this.form.selectbox.rem.function
      const hold = this.form.selectbox.rem.holdFunction

      const isPressRelease = fn === 'SecondPTT'
      const isPress =
        hold === 'None' ||
        (fn === 'GroupDown' && hold === 'GroupDown(Continuous)') ||
        (fn === 'GroupUp' && hold === 'GroupUp(Continuous)')

      data.REM['Function(Press)'] = isPressRelease || isPress ? fn : 'None'
      data.REM['Function(Release)'] = isPressRelease || !isPress ? fn : 'None'
      data.REM.HoldFunction = hold

      data.REM.SwapFunctionsREMandPTT = this.form.toggle.rem.swapFunctionsREMandPTT
        ? BC.COMMON.TOGGLE.ENABLE
        : BC.COMMON.TOGGLE.DISABLE
    },

    transSetting2Form() {
      const data = this.setting.KeyAssignment.MicKey

      const isPress =
        data.REM.HoldFunction === 'None' ||
        (data.REM['Function(Press)'] === 'GroupDown' &&
          data.REM.HoldFunction === 'GroupDown(Continuous)') ||
        (data.REM['Function(Press)'] === 'GroupUp' &&
          data.REM.HoldFunction === 'GroupUp(Continuous)')

      this.form.selectbox.rem.function = isPress
        ? data.REM['Function(Press)']
        : data.REM['Function(Release)']
      this.form.selectbox.rem.holdFunction = data.REM.HoldFunction

      this.form.toggle.rem.swapFunctionsREMandPTT =
        data.REM.SwapFunctionsREMandPTT === BC.COMMON.TOGGLE.ENABLE
    },

    updateSelectboxOptions() {
      const menuData = this.setting.KeyAssignment.Menu
      const extendedMenuData = this.setting.KeyAssignment.ExtendedMenu

      const hasMenuAutoBacklight =
        menuData.some((item) => item.Function.includes('AutoBacklight')) ||
        extendedMenuData.some((item) => item.Function.includes('AutoBacklight'))

      const formFunction = this.form.selectbox.rem.function
      const formHoldFunction = this.form.selectbox.rem.holdFunction

      // function options
      this.selectboxOptions.function = FUNCTION_LIST.map((ele) => {
        if (
          ele.type.key &&
          ele.function?.function &&
          !(hasMenuAutoBacklight && ele.value === 'Backlight')
        ) {
          return { label: ele.label, value: ele.value }
        }
      }).filter(Boolean)

      // holdFunction options
      this.selectboxOptions.holdFunction = FUNCTION_LIST.map((ele) => {
        if (
          (ele.type.key &&
            ele.function?.holdFunction &&
            !(hasMenuAutoBacklight && ele.value === 'Backlight')) ||
          (formFunction === 'GroupDown' && ele.value === 'GroupDown(Continuous)') ||
          (formFunction === 'GroupUp' && ele.value === 'GroupUp(Continuous)') ||
          (formHoldFunction === 'Emergency' && ele.value === 'Emergency')
        ) {
          return { label: ele.label, value: ele.value }
        }
      }).filter(Boolean)
    },

    handleSelectFunction(value) {
      this.form.selectbox.rem.function = value

      const holdFunctionDefault = FUNCTION_LIST.find((ele) => ele.value === value)?.function
        ?.holdFunctionDefault
      if (holdFunctionDefault) {
        this.form.selectbox.rem.holdFunction = holdFunctionDefault
      }

      // SecondPTT のときは HoldFunction を非活性
      this.holdFunctionSelectDisable = this.form.selectbox.rem.function === 'SecondPTT'

      this.updateSelectboxOptions()
    },

    handleSelectHoldFunction(value) {
      this.form.selectbox.rem.holdFunction = value
    },
  },
  mounted() {
    // 設定 → フォームへ反映
    this.transSetting2Form()
    this.updateSelectboxOptions()

    // Emergency(REM) 割り当てが有効なら function/holdFunction を非活性
    const general = this.setting.KeyAssignment.General
    if (general.Emergency.REM === BC.COMMON.TOGGLE.ENABLE) {
      this.functionSelectDisable = true
      this.holdFunctionSelectDisable = true
    }

    // 選択中の function が SecondPTT なら hold 側を非活性
    if (this.form.selectbox.rem.function === 'SecondPTT') {
      this.holdFunctionSelectDisable = true
    }
  },
}
</script>

<template>
  <div>
    <SettingGroup title="REM">
      <SettingItem label="ファンクション">
        <SelectBox
          :disabled="functionSelectDisable"
          :options="selectboxOptions.function"
          :defaultValue="String(form.selectbox.rem.function)"
          @update="handleSelectFunction"
        />
      </SettingItem>

      <SettingItem label="ホールド・ファンクション">
        <SelectBox
          :disabled="holdFunctionSelectDisable"
          :options="selectboxOptions.holdFunction"
          :defaultValue="String(form.selectbox.rem.holdFunction)"
          @update="handleSelectHoldFunction"
        />
      </SettingItem>

      <SettingItem label="REM キーと PTT スイッチを入替え">
        <ToggleSwitch
          v-model="form.toggle.rem.swapFunctionsREMandPTT"
          :disable="false"
        />
      </SettingItem>
    </SettingGroup>
  </div>
</template>
